(function () {
  var KEY = 'mi-lang';
  var lang = 'en';
  try {
    lang = localStorage.getItem(KEY) || ((navigator.language || '').toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en');
  } catch (e) {}

  window.MIlang = function () { return lang; };

  function paint() {
    document.querySelectorAll('[data-en]').forEach(function (el) {
      var t = el.getAttribute('data-' + lang);
      if (t !== null) el.textContent = t;
    });
    document.querySelectorAll('.mi-lang').forEach(function (b) {
      b.textContent = lang === 'en' ? 'FR' : 'EN';
      b.setAttribute('aria-label', lang === 'en' ? 'Passer en français' : 'Switch to English');
    });
    document.querySelectorAll('[data-ph-en]').forEach(function (el) {
      el.setAttribute('placeholder', el.getAttribute('data-ph-' + lang));
    });
    document.documentElement.lang = lang === 'en' ? 'en-CA' : 'fr-CA';
    if (window.MIquiz) window.MIquiz.render();
  }
  window.MIpaint = paint;

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.mi-lang');
    if (!b) return;
    lang = lang === 'en' ? 'fr' : 'en';
    try { localStorage.setItem(KEY, lang); } catch (err) {}
    paint();
  });

  /* ---------- mattress finder (homepage only) ---------- */
  function initQuiz() {
    var root = document.getElementById('mi-quiz');
    if (!root || !window.MI_P) return;
    var D = window.MI_P;
    var H = { spare: 'the-spare', starter: 'the-starter', everyday: 'the-everyday', firm: 'the-firm', buyonce: 'the-buy-once', crib: 'the-crib' };

    function money(n) { return lang === 'en' ? '$' + n : n + ' $'; }
    function info(k) {
      var p = D[H[k]];
      if (!p) return null;
      var pr = p.prices, main, sz;
      if (pr.Queen !== undefined) {
        main = pr.Queen;
        var bits = ['Queen'];
        if (pr.Single !== undefined) bits.push(money(pr.Single) + (lang === 'en' ? ' single' : ' simple'));
        if (pr.King !== undefined) bits.push(money(pr.King) + ' king');
        else if (pr.Double !== undefined) bits.push(money(pr.Double) + ' double');
        sz = bits.join(' · ');
      } else {
        var keys = Object.keys(pr);
        main = pr[keys[0]];
        sz = lang === 'en' ? 'One size' : 'Format unique';
      }
      return { n: p.n, u: p.u, p: money(main), sz: sz };
    }

    var T = {
      baby: { why: { en: "The only crib size we make. Firm, which is what infants need.", fr: "Le seul format bébé qu'on fait. Ferme, comme il le faut pour un nourrisson." }, alt: null },
      guest: { why: { en: "A few nights a year doesn't need more than five inches of foam. Paying more buys durability you'll never use up.", fr: "Quelques nuits par année n'exigent pas plus de cinq pouces de mousse. Payer plus, c'est acheter une durabilité que vous n'userez jamais." }, alt: { en: "If guests stay a week at a time, The Starter is worth the jump.", fr: "Si vos invités restent une semaine, le Starter vaut le coup." } },
      kid: { why: { en: "Light body, single frame, and they'll outgrow it before it wears out.", fr: "Corps léger, lit simple, et il sera trop grand avant que le matelas s'use." }, alt: { en: "Over about 12, The Starter in a single lasts through the teenage years.", fr: "Passé 12 ans, le Starter en simple tiendra l'adolescence." } },
      rental: { why: { en: "Full-depth foam. No springs to go noisy, nothing to flip, cheap enough to replace between tenants.", fr: "Mousse pleine épaisseur. Pas de ressorts qui grincent, rien à retourner, assez abordable pour remplacer entre deux locataires." }, alt: { en: "For short-term rentals where mattresses get destroyed, The Spare is the one to burn through.", fr: "Pour la location court terme où les matelas se font détruire, le Spare est celui à sacrifier." } },
      firm: { why: { en: "Stomach sleeping and lower-back pain both need your hips held up, not sinking. This is the only genuinely firm bed we make, and it flips.", fr: "Dormir sur le ventre et le mal de bas du dos exigent tous deux que les hanches restent soutenues. C'est notre seul matelas vraiment ferme, et il se retourne." }, alt: { en: "The Everyday is a medium with real edge support. Softer than ideal for you, and it won't last as long, but it costs less.", fr: "L'Everyday est un médium avec un vrai soutien des bords. Plus mou que l'idéal pour vous, et moins durable, mais moins cher." } },
      buyonce: { why: { en: "Side sleeping puts your whole weight through one shoulder and one hip. This is the only mattress we make that gives there.", fr: "Dormir sur le côté fait passer tout votre poids par une épaule et une hanche. C'est le seul matelas qu'on fait qui cède à ces endroits." }, alt: { en: "The Everyday has coils with a thinner top. Expect a shoulder to complain, but it costs less.", fr: "L'Everyday a des ressorts avec un dessus plus mince. Une épaule risque de se plaindre, mais c'est moins cher." } },
      everyday: { why: { en: "Back or mixed sleeper with nothing hurting is the easy case. Coils, reinforced edges, medium top. Most people should buy this one.", fr: "Dormeur sur le dos ou mixte sans douleur : le cas facile. Ressorts, bords renforcés, dessus médium. C'est celui que la plupart des gens devraient prendre." }, alt: { en: "The Starter is all foam: less bounce, and you'll replace it around year five instead of year seven.", fr: "Le Starter est tout en mousse : moins de rebond, à remplacer vers l'an cinq plutôt que sept." } }
    };
    var ALT = { guest: 'starter', kid: 'starter', rental: 'spare', firm: 'everyday', buyonce: 'everyday', everyday: 'starter' };

    var st = { use: null, pos: null, pain: null };
    function $(id) { return document.getElementById(id); }

    function decide() {
      var u = st.use;
      if (!u) return null;
      if (u === 'baby') return { k: 'crib', t: 'baby' };
      if (u === 'guest') return { k: 'spare', t: 'guest' };
      if (u === 'kid') return { k: 'spare', t: 'kid' };
      if (u === 'rental') return { k: 'starter', t: 'rental' };
      if (!st.pos || !st.pain) return null;
      if (st.pain === 'lowerback' || st.pos === 'stomach') return { k: 'firm', t: 'firm' };
      if (st.pain === 'hips' || st.pos === 'side') return { k: 'buyonce', t: 'buyonce' };
      return { k: 'everyday', t: 'everyday' };
    }

    function render() {
      var main = st.use === 'main';
      $('mi-q2').hidden = !main;
      $('mi-q3').hidden = !(main && st.pos);
      var r = decide();
      var box = $('mi-res');
      if (!r) { box.hidden = true; return; }
      var p = info(r.k);
      if (!p) { box.hidden = true; return; }
      $('mi-rn').textContent = p.n;
      $('mi-rp').innerHTML = '';
      $('mi-rp').appendChild(document.createTextNode(p.p + ' '));
      var sm = document.createElement('small'); sm.textContent = p.sz; $('mi-rp').appendChild(sm);
      $('mi-rw').textContent = T[r.t].why[lang];
      var go = $('mi-rgo');
      go.href = p.u;
      go.textContent = (lang === 'en' ? 'Choose a size' : 'Choisir le format');
      var alt = T[r.t].alt, ab = $('mi-rabox');
      if (alt) {
        var ai = info(ALT[r.t]);
        ab.hidden = false;
        $('mi-ra').textContent = alt[lang] + (ai ? ' (' + ai.p + ' Queen)' : '');
      } else { ab.hidden = true; }
      box.hidden = false;
    }

    function clear(k) {
      var g = root.querySelector('.opts[data-q="' + k + '"]');
      if (g) g.querySelectorAll('button').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
    }

    root.querySelectorAll('.opts').forEach(function (g) {
      var key = g.getAttribute('data-q');
      g.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          clear(key);
          b.setAttribute('aria-pressed', 'true');
          st[key] = b.getAttribute('data-v');
          if (key === 'use' && st.use !== 'main') { st.pos = null; st.pain = null; clear('pos'); clear('pain'); }
          if (key === 'pos') { st.pain = null; clear('pain'); }
          render();
        });
      });
    });

    $('mi-reset').addEventListener('click', function () {
      st = { use: null, pos: null, pain: null };
      ['use', 'pos', 'pain'].forEach(clear);
      render();
    });

    window.MIquiz = { render: render };
  }

  /* ---------- product page size picker ---------- */
  function initPdp() {
    var f = document.querySelector('.mi-pdp form');
    if (!f) return;
    function upd() {
      var c = f.querySelector('input[name="id"]:checked');
      if (!c) return;
      var n = c.getAttribute('data-price');
      var el = document.getElementById('mi-pdp-price');
      el.setAttribute('data-en', '$' + n);
      el.setAttribute('data-fr', n + ' $');
      el.textContent = lang === 'en' ? '$' + n : n + ' $';
    }
    f.addEventListener('change', upd);
    upd();
    /* add-on boxes: add the mattress and the ticked add-ons in one request, then go to the cart */
    f.addEventListener('submit', function (e) {
      var extra = f.querySelectorAll('[data-addon]:checked');
      var c = f.querySelector('input[name="id"]:checked') || f.querySelector('input[name="id"]');
      if (!extra.length || !c) return;
      e.preventDefault();
      var items = [{ id: +c.value, quantity: 1 }];
      extra.forEach(function (x) { items.push({ id: +x.getAttribute('data-addon'), quantity: 1 }); });
      fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { location.href = shopRoot + 'cart'; }, function () { f.submit(); });
    });
  }

  /* ---------- hero price board: size switch ---------- */
  function initBoard() {
    var root = document.getElementById('mi-board');
    if (!root) return;
    var btns = root.querySelectorAll('[data-size]');
    function set(size, animate) {
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-size') === size ? 'true' : 'false'); });
      root.querySelectorAll('.rc-row').forEach(function (row) {
        var n = JSON.parse(row.getAttribute('data-prices'))[size];
        var box = row.querySelector('.rc-p');
        var el = box.querySelector('[data-en]') || box;
        el.setAttribute('data-en', n ? '$' + n : '—');
        el.setAttribute('data-fr', n ? n + ' $' : '—');
        el.textContent = el.getAttribute('data-' + lang);
        row.classList.toggle('na', !n);
        if (animate) { box.classList.remove('tick'); void box.offsetWidth; box.classList.add('tick'); }
      });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-size]');
      if (b) set(b.getAttribute('data-size'), true);
    });
  }

  /* ---------- cart: steppers + mobile checkout bar ---------- */
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function initCart() {
    var orphan = document.querySelector('.ct-empty[data-orphans]');
    if (orphan) {
      fetch(shopRoot + 'cart/clear.js', { method: 'POST' }).then(function () { location.reload(); });
      return;
    }
    var f = document.getElementById('mi-cart-form');
    if (!f) return;
    f.addEventListener('click', function (e) {
      var b = e.target.closest('.qbtn');
      if (!b) return;
      var i = b.parentNode.querySelector('input');
      i.value = Math.max(0, (parseInt(i.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10));
      f.classList.add('busy');
      f.submit();
    });
    f.addEventListener('change', function (e) {
      var n = e.target.name || '';
      if (n.indexOf('updates[') === 0) { f.classList.add('busy'); f.submit(); }
      else if (n === 'mi-speed') setLines(xp, e.target.value === 'xp' ? 1 : 0);
      else if (n === 'mi-removal') setLines(rm, e.target.checked ? mats : 0);
    });

    /* add-ons are real cart lines: express (always 1) and removal (1 per mattress) */
    var mats = +f.getAttribute('data-mats');
    var xp = f.getAttribute('data-xp'), rm = f.getAttribute('data-rm');
    var xpq = +f.getAttribute('data-xpq'), rmq = +f.getAttribute('data-rmq');
    function setLines(id, q) {
      if (!id) return;
      var u = {}; u[id] = q;
      f.classList.add('busy');
      fetch(shopRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) })
        .then(function () { location.reload(); }, function () { location.reload(); });
    }
    if (xpq > 1) setLines(xp, 1);
    else if (rmq > 0 && rmq !== mats) setLines(rm, mats);
    var bar = document.getElementById('mi-cart-bar');
    var sum = document.getElementById('mi-checkout');
    if (bar && sum && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var hidden = !es[0].isIntersecting;
        bar.classList.toggle('on', hidden);
        document.body.classList.toggle('mi-bar-on', hidden);
        bar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        bar.querySelector('button').tabIndex = hidden ? 0 : -1;
      }).observe(sum);
    }
  }

  /* ---------- delivery: "order today, there by …" (business days, weekends skipped; holidays not counted) ---------- */
  function initEta() {
    document.querySelectorAll('[data-bdays]').forEach(function (el) {
      var d = new Date(), left = +el.getAttribute('data-bdays');
      while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) left--; }
      var o = { weekday: 'short', month: 'short', day: 'numeric' };
      el.setAttribute('data-en', 'Order today: there by ' + d.toLocaleDateString('en-CA', o) + '.');
      el.setAttribute('data-fr', "Commandez aujourd'hui : livré d'ici le " + d.toLocaleDateString('fr-CA', o).replace(/\.$/, '') + '.');
    });
  }

  initQuiz();
  initEta();
  initBoard();
  initCart();
  initPdp();
  paint();
})();
